<app-header></app-header>

<ion-content
  id="menu-profit-pro"
  class="gray-content-bg"
  [class.desktop]="platformService?.platformType === platformService?.platformEnum?.desktop "
  [class.mobile]="platformService?.platformType !== platformService?.platformEnum?.mobile "
  [class.tablet]="platformService?.platformType !== platformService?.platformEnum?.tablet "
  *ngIf="(viewModel$ | async) as viewModel"
  [class.mobile-content]="platformService?.platformType === platformService?.platformEnum?.mobile"
>
  <div class="header-section">
    <ion-grid
      [fixed]="true"
      [class.mobile]="platformService?.platformType === platformService?.platformEnum?.mobile"
    >
      <ion-row class="default-data">
        <ion-col size="10.5">
          <div class="image-and-details">
            <ng-container
              [ngTemplateOutlet]="recipeImage"
              [ngTemplateOutletContext]="{viewModel:viewModel}"
            ></ng-container>
            <ng-container
              [ngTemplateOutlet]="recipeDetailsSmall"
              [ngTemplateOutletContext]="{viewModel:viewModel}"
            ></ng-container>
          </div>
        </ion-col>
        <ion-col offset="0.5" size="1">
          <ion-icon
            class="chevron"
            [name]="viewModel.details.showPortion ?  'chevron-down-outline': 'chevron-up-outline'"
            (click)="clickShowHidePortion(viewModel.details.showPortion)"
          >
          </ion-icon>
        </ion-col>
      </ion-row>
      <ion-row *ngIf="!!viewModel.details.showPortion">
        <ion-col size="12">
          <app-edit-portion
            [yield]="viewModel.yield"
            [serving]="viewModel.servingSizeQuantity"
            [servingPerRecipe]="viewModel.servingPerBatch"
            [servingUOM]="viewModel.servingSizeUom ?? 'i18n.menuProfitPro.recipeDetail.cup'"
            [yieldUOM]="viewModel.displayYieldUom ?? 'i18n.menuProfitPro.recipeDetail.cup'"
            [platform]="platformService.platformType"
            (yieldValueEvent)="handleYieldChange($event, viewModel.recipeId)"
            (servingValueEvent)="handleServingChange($event, viewModel.recipeId)"
            (servingPerRecipeEvent)="handleServingPerRecipeChange($event, viewModel.recipeId)"
            (servingUOMEvent)="handleShowServingUOM($event, viewModel.recipeId)"
            (yieldUOMEvent)="handleShowYieldUOM($event, viewModel.recipeId)"
            [lockEdits]="viewModel.lockRecipeEdits"
          >
          </app-edit-portion>
        </ion-col>
      </ion-row>
      <ion-row
        *ngIf="(viewModel.transformedIngredientData ?? []).length > 0"
        class="search-add"
      >
        <ion-col size="3"></ion-col>
        <ion-col offset="4" size="5" class="add-column">
          <div>
            <ng-container
              [ngTemplateOutlet]="addIngredientsButton"
              [ngTemplateOutletContext]="{viewModel:viewModel}"
            ></ng-container>
          </div>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
  <div class="lower-section">
    <ion-grid class="ingredients-container">
      <app-ingredients-mobile-container
        [ingredients]="viewModel.transformedIngredientData"
        [searchKey]="''"
        [platform]="platformService.platformType"
        [lockEdits]="viewModel.lockRecipeEdits"
        (addIngredientsEvent)="openIngredientSearchModal()"
        (ellipsisEvent)="handleIngredientEllipsisClick($event, viewModel.recipeId)"
        (costInfoIconEvent)="handleCostInfoIconClickEvent($event)"
        (nameClickEvent)="onNameClick($event)"
      >
      </app-ingredients-mobile-container>
    </ion-grid>
  </div>
  <app-footer></app-footer>

  <ion-modal
    [isOpen]="isIngredientDetailModalIsOpen$ | async"
    [class]="
    (platformService?.isTouchExperience$ | async)
      ? 'ion-modal-touch'
      : 'modal-desktop-size-xl'
  "
    (ionModalDidDismiss)="closeIngredientDetailsModal()"
    [initialBreakpoint]="
    platformService?.platformType !== platformService?.platformEnum.desktop
      ? 1
      : undefined
  "
    [breakpoints]="
    platformService?.platformType !== platformService?.platformEnum.desktop
      ? [0, 1]
      : undefined
  "
  >
    <ng-template>
      <app-ingredient-detail-touch-modal
        class="ion-page"
        [platform]="platformService.platformType"
        [readyToShow]="viewModel.rightHandVal > 3"
        [product]="viewModel.lastSelectedProduct"
        [isOnline]="viewModel.isOnline"
        [pricingDisabled]="viewModel.pricingDisabled"
        [currentCalculations]="viewModel.currentCalculations"
        [showInfoIcon]="showSubHeaderInfoIcon"
        [cardData]="viewModel.selectedCard"
        [lockEdits]="viewModel.lockRecipeEdits"
        [isDefault]="viewModel.selectedCard?.isDefault || false"
        [defaultItemName]="viewModel.selectedCard?.itemName"
        (closeEvent)="closeIngredientDetailsModal()"
        (ellipsisEvent)="openProductEllipsisClick($event)"
        (productEvent)="openProductDetails($event)"
        (baseUnitEvent)="handleClickBaseUnit($event, viewModel.currentCalculations)"
        (conversionUnitEvent)="handleClickConversionUnit($event,viewModel.currentCalculations)"
        (resultUnitEvent)="handleClickResultsUnit($event,viewModel.currentCalculations)"
        (baseQuantityEvent)="updateBaseQunatity($event,viewModel.currentCalculations)"
        (conversionQuantityEvent)="updateConversionQuantity($event,viewModel.currentCalculations)"
        (uomDropdownClickEvent)="handleShowIngredientUom($event, viewModel.recipeId)"
        (noteInputBlurEvent)="handleIngredientNoteChange($event, viewModel.recipeId)"
        (quantityInputBlurEvent)="handleIngredientQuantityChange($event, viewModel.recipeId)"
        (saveChangesEvent)="saveUnitsOfMeasureCalculations($event, viewModel.currentCalculations, viewModel.currentUnitsOfMeasure, viewModel.lastSelectedProduct?.productNumber)"
        (infoIconEvent)="clickInfoIcon($event, false)"
        (dismissEvent)="closeIngredientDetailsModal()"
      >
      </app-ingredient-detail-touch-modal>
    </ng-template>
  </ion-modal>

  <ion-modal
    [isOpen]="isIngredientSearchModalOpen$ | async"
    (ionModalDidDismiss)="closeIngredientSearchModal()"
    [class]="
    (platformService?.isTouchExperience$ | async)
      ? 'ion-modal-touch'
      : 'modal-desktop-size-xl'
  "
    [initialBreakpoint]="
    platformService?.platformType !== platformService?.platformEnum.desktop
      ? 1
      : undefined
  "
    [breakpoints]="
    platformService?.platformType !== platformService?.platformEnum.desktop
      ? [0, 1]
      : undefined
  "
  >
    <ng-template>
      <app-ingredient-search-modal
        class="ion-page"
        [platform]="platformService.platformType"
        [recipeSearchResult]="searchResultsForIngredient$"
        [ingredientName]=""
        [productSearchResult]="searchResultsForProduct$"
        [searchTimeoutTracker]="searchTimeoutTracker$ | async"
        [showNonUsfFeature]="viewModel.mppFeatureflags.showAddNonUsfProductButton"
        (searchEvent)="handleNewIngredientSearchRequest($event)"
        (submitEvent)="handleNewIngredientSearchSubmission($event)"
        (dismissEvent)="closeIngredientSearchModal()"
        (viewAllProductsEvent)="handleProductViewAll($event)"
        (addNonUsfProductEvent)="handleAddNonUsfProductEvent()"
      >
      </app-ingredient-search-modal>
    </ng-template>
  </ion-modal>

  <app-add-non-usf-product-container
    (dismissEvent)="handleAddNonUsfProductDismissEvent()"
    (submitEvent)="handleAddNonUsfProducSubmitEvent($event)"
    (navigationEvent)="closeIngredientSearchModal()"
  ></app-add-non-usf-product-container>
</ion-content>

<ion-modal
  [isOpen]=" isDeleteIngredientModalOpen$ | async"
  (ionModalDidDismiss)="dismissDeleteIngredientModal()"
  [ngClass]="'ion-modal-touch'"
  [initialBreakpoint]="platformService.platformType !== platformService.platformEnum.desktop ? 1 : undefined"
  [breakpoints]="platformService.platformType !== platformService.platformEnum.desktop  ? [0, 1] : undefined"
  id="delete-ingredient-modal"
>
  <ng-template>
    <app-ingredient-deletion-modal
      class="ion-page"
      [platform]="platformService.platformType"
      [params]="recipeDetailService.currentDeleteParams"
      (dismissEvent)="dismissDeleteIngredientModal()"
      (submitEvent)="handleDeleteIngredientSubmit()"
    >
    </app-ingredient-deletion-modal>
  </ng-template>
</ion-modal>

<ng-template #recipeImage let-viewModel="viewModel">
  <div>
    <img
      *ngIf="!!viewModel.imageSrc"
      class="recipe-image"
      [attr.data-cy]="'recipe-card-image'"
      [src]="viewModel.imageSrc"
    />
    <div
      *ngIf="!viewModel.imageSrc"
      data-cy="recipe-no-image-icon"
      class="recipe-image"
    >
      <ion-icon name="restaurant"></ion-icon>
    </div>
  </div>
</ng-template>

<ng-template #recipeDetailsSmall let-viewModel="viewModel">
  <div>
    <p class="bold text-heading">
      {{viewModel.recipeName | truncateWithEllipsis: viewModel.truncateCount}}
    </p>
    <p class="shift text-body">
      <span
        >{{ 'i18n.menuProfitPro.recipeDetail.costServing2' | translate}}</span
      >
      <span class="bold">{{ viewModel.costPerServing ?? 0 | currency}} </span>
    </p>
    <p class="shift text-body">
      <span
        >{{ 'i18n.menuProfitPro.recipeDetail.costRecipe2' | translate}}</span
      >
      <span class="bold">{{ viewModel.cost ?? 0 | currency}} </span>
    </p>
  </div>
</ng-template>

<ng-template #addIngredientsButton let-viewModel="viewModel">
  <ion-button
    [class]="'usf-fill-green-button add-ing'"
    data-cy="recipe-page-add-ingredient-button"
    (click)="openIngredientSearchModal()"
    [disabled]="viewModel.lockRecipeEdits"
    [class.disabled]="viewModel.lockRecipeEdits"
  >
    {{ 'i18n.common.add' | translate }}
    <ion-icon
      data-cy="recipe-page-add-ingredient-button-icon"
      name="add-outline"
    ></ion-icon>
  </ion-button>
</ng-template>

<ng-template #recipeDetailsLarge let-viewModel="viewModel"> </ng-template>
